import { render } from "./ExecutionDetail.vue?vue&type=template&id=2b090c3b&scoped=true"
import script from "./ExecutionDetail.vue?vue&type=script&lang=js"
export * from "./ExecutionDetail.vue?vue&type=script&lang=js"

import "./ExecutionDetail.vue?vue&type=style&index=0&id=2b090c3b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b090c3b"]])

export default __exports__